import { getRegisterFunction } from '../../utils/register.js';
import { OneUxFieldElement } from './OneUxFieldElement.js';
export const register = getRegisterFunction(OneUxFieldElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-field': OneUxFieldElement;
    "field-4e36f4d6fe636f6452470209ca6b5a53": OneUxFieldElement;
  }
}